import React from 'react';
import { Button as AntdButton } from 'antd';
import { ButtonProps as AntdButtonProps } from 'antd/lib/button';
import classNames from 'classnames';
import './index.style.less';

export interface ButtonProps extends AntdButtonProps {
  className?: string;
  rounded?: boolean;
  half?: boolean;
}

const Button = ({
  className,
  rounded,
  half,
  children,
  ...rest
}: React.PropsWithChildren<ButtonProps>): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <AntdButton className={classNames('button', className, { rounded }, { half })} {...rest}>
      {children}
    </AntdButton>
  );
};

export default Button;
